import { Box, Heading } from '@zillow/constellation-10';

import {
  wizardFormColumnStyles,
  wizardFormSectionContainerStyles,
  wizardGridContainerStyles,
  wizardHeadingStyles,
} from '../../../../styles/wizard';

import RoomUtilitiesFormField from '../../../PostingPath/RoomUtilitiesFormField';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RoomUtilitiesAmount = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => {
  return (
    <PageWizard
      {...rest}
      title=""
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onGoToNextStep || undefined}
      onBackClick={onGoToPrevStep || undefined}
      onExitTriggered={onExitWizard}
    >
      <Box css={wizardGridContainerStyles}>
        <Box css={wizardFormColumnStyles}>
          <Box css={wizardFormSectionContainerStyles.raw()} data-testid="DescribeRoommates">
            <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
              What is the renter&apos;s share of the monthly utilities?
            </Heading>

            <RoomUtilitiesFormField />
          </Box>
        </Box>
      </Box>
    </PageWizard>
  );
};

export default RoomUtilitiesAmount;
